import { Route, Routes } from "react-router-dom";
import UsersPage from "../../app/users";
import UsersIDPage from "../../app/users/id";
import UserEditPage from "../../app/users/id/edit";

export default function UsersRoutes() {
  return (
    <Routes>
      <Route path="/" element={<UsersPage />} />
      <Route path="/:id" element={<UsersIDPage />} />
      <Route path="/:id/edit" element={<UserEditPage />} />
    </Routes>
  );
}
